import React, { useEffect, useState } from 'react'
import SecondaryMenu from '../components/SecondaryMenu'
import { useSelector, useDispatch } from 'react-redux';
import md5 from 'md5';
import axios from 'axios';
import { setData } from '../features/altriOneri';
import { CircularProgress } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DateTime, Interval } from 'luxon';
import { setShowPicker } from '../features/settingSlice';
import '../style/AltriOneri.scss';
import IntervalPicker from '../components/IntervalPicker';
import Item from '../components/AltriOneri/_Item';
import SubHeader from '../components/SubHeader';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';

function AltriOneri() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const customerCode = useSelector((user) => user.user.info.customer_code);
    const customerId = useSelector((user) => user.user.info.customer_id)
    const data = useSelector((user) => user.altriOneri.data)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const [counterPosts, setCounterPosts] = useState(5);
    const showPicker = useSelector((user) => user.settings.showPicker);
    const [intervalFilter, setIntervalFilter] = useState({
        label: 'Tutti',
        interval: Interval.fromDateTimes(DateTime.local(2000), DateTime.local()),
    });
    const [render, setRender] = useState(false)


    useEffect(() =>{
        init()
        if(render === true) {
            init()
            setRender(false)
        }
    },[customerCode, render])

    const init = async () => {
        const oneriApi = `https://my.revoluce.it/area_utente/gestione/api/movements/getOneriDiversi.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const res = await axios.get(oneriApi)
        dispatch(setData(res.data.elenco))
        console.log(res.data.elenco)
    }   

    const toDateTime = (dataItem) => DateTime.fromISO(dataItem.entry_date);
    let monthsInterval, filteredData = [];
    if (data && data.length > 0) {
        const dates = [toDateTime(data[0]), toDateTime(data[data.length - 1])];
        const min = DateTime.min(...dates).startOf('month');
        const max = DateTime.max(...dates).endOf('month');
        monthsInterval = Interval.fromDateTimes(min, max);
        const { interval } = intervalFilter;
        filteredData = data.filter(r => interval.contains(toDateTime(r)));
    }
    const openIntervalFilter = () => {
        if (monthsInterval) dispatch(setShowPicker(true));
    };
    return (    
        <>
            <div className="altriOneri">
                {data === null ? (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <div className="header">
                            <div className="filterDate" onClick={openIntervalFilter}>
                                <div className="icon">
                                    <CalendarTodayIcon />
                                </div>
                                <p className="label">{intervalFilter.label}</p>
                            </div>
                        </div>
                        <div className="items">
                            {filteredData.slice(0, counterPosts).map((r, i) => (
                                <Item key={i} item={r}  render={setRender} />
                            ))}
                        </div>
                    </>
                )}
                {data === null ? null : counterPosts >= filteredData.length ? (
                    <div className="lastItem">
                        <p className="no-more">Non ci sono altri documenti da visualizzare</p>
                    </div>
                ) : (
                    <div className="lastItem" onClick={() => setCounterPosts(counterPosts + 3)}>
                        <p className="load-more">Clicca per caricare altri documenti</p>
                    </div>
                )}
            </div>
            {showPicker && <IntervalPicker monthsInterval={monthsInterval} onSelect={(newIntervalFilter) => {
                setIntervalFilter(newIntervalFilter);
                dispatch(setShowPicker(false));
            }} />}
        </>
    )
}

export default AltriOneri
